import * as React from 'react';

import GenericFeaturedContent from '@lendi-jam/generic-featured-content';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';

import { GenericFeaturedContentProps } from '#contentTypes/GenericFeaturedContent';

import { parseSharpObject } from '../lib/prismicFunctions';

interface PrismicGenericFeaturedContentProps {
  component: GenericFeaturedContentProps;
}

const PrismicGenericFeaturedContent: React.FC<PrismicGenericFeaturedContentProps> = ({ component }) => {
  const FeaturedContentPrimary = component.primary;
  const FeaturedContentFields = component.items;

  return (
    <GenericFeaturedContent
      title={FeaturedContentPrimary.featured_title?.text}
      items={FeaturedContentFields.map((item) => {
        const parsedChildImage = parseSharpObject(item.content_image?.url, item.content_image);

        return {
          title: item.content_title.text,
          body: item.content_description.text,
          link: {
            url: embedMarketingTrackingIntoURL(item.content_link?.url),
            text: 'Read more',
          },
          image: {
            url: item.content_image?.url || '',
            alt: item.content_image?.alt,
          },
          imageSharp: parsedChildImage?.fluid || {
            aspectRatio: 0,
            src: item.content_image?.url || '',
            srcSet: '',
            sizes: '',
          },
        };
      })}
    />
  );
};

export default PrismicGenericFeaturedContent;
